import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light', // or 'dark'
    primary: {
      main: '#1976d2', // blue
    },
    secondary: {
      main: '#f50057', // pink
    },
  },
  typography: {
    fontFamily: 'Segoe UI, Roboto, sans-serif',
    fontSize: 16,
  },
});

export default theme;
